<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <settings-editor-base
        v-bind:label="label"
    >
        <template v-slot="{inputId}">
            <div class="row">
                <div class="col-12">
                    <button class="btn btn-primary" v-bind:id="inputId" @click="showPicker">
                        Browse
                    </button>

                     <i
                            v-if="hasImage"
                            class="fas fa-lg fa-trash-alt mdb-icon-btn delete float-right mt-2"
                            aria-hidden="true"
                            @click.stop="promptRemoveFile">
                    </i>
                </div>
                <div class="col-12" v-if="name">
                    <label> {{name}} </label>
                </div>

                <modal ref="pickerModal">
                    <template v-slot:modal-header></template>

                    <template v-slot:modal-body>
                        <media-library
                                v-bind:mediaId="mediaId"
                                @file-picked="filePicked"
                        ></media-library>
                    </template>

                    <!-- Empty our footer -->
                    <template v-slot:modal-footer></template>
                </modal>
            </div>
        </template>
    </settings-editor-base>
</template>

<script>
    import mediaLibraryApi from '../../../../Api/media-library';
    
    import Modal from "../../../../Components/Util/Modal.vue";
    
    import MediaLibrary from '../../../MediaLibrary/Components/MediaLibrary.vue';
    import SettingsEditorBase from './SettingsEditorBase.vue';

    import {promptV2 as prompt} from "../../../../Util/prompt";
    import resourceMixin from "../../../../Util/Mixins/resources";
    
    export default {
        name: "settings-media-picker",
        mixins: [resourceMixin],
        components: {
            SettingsEditorBase,
            Modal,
            MediaLibrary
        },
        created(){
            const vm = this;
            
            if(vm.mediaId){
                vm.updateInfo(vm.mediaId);
            }
        },
        methods: {
            filePicked(id){
                const vm = this;

                //Modal should autoclose on file select
                vm.$refs.pickerModal.hide();
                vm.$emit('file-picked', id);
            },
            showPicker(){
                const vm = this;

                vm.$refs.pickerModal.show();
            },
            updateInfo(mediaId){
                const vm = this;

                mediaLibraryApi.getFileInfo(mediaId)
                    .then(info => vm.name = info.name);
            },
            reset(){
                const vm = this;
                
                vm.name = null;
            },
            promptRemoveFile(){
                const vm = this;
                
                prompt(
                    vm.resource('TemplateManager_Shared_RemoveMediaPrompt_Title'),
                    vm.resource('TemplateManager_Shared_RemoveMediaPrompt_Body')
                ).then(
                    () => vm.$emit('file-picked', null),
                    () => { /*Do nothing */ }
                );
            }
        },
        computed: {
            hasImage() {
                return this.mediaId != null;
            }
        },
        watch: {
            mediaId(val) {
                const vm = this;
                
                //Media is not guaranteed to be selected
                if(val){
                    vm.updateInfo(val);
                }
                else{
                    vm.reset();
                }
            }
        },
        data: () => ({
            name: null
        }),
        props: {
            label: {
                type: String,
                required: true
            },
            isBackGround: {
                type: Boolean,
                default: false
            },
            mediaId: String
        }
    };
</script>

<style scoped src="../../Style/settings-media-picker.scss" lang="scss"></style>
